var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("ellipse",{"cx":"7.399","cy":"7.88","stroke":"#fff","strokeLinecap":"round","strokeLinejoin":"round","rx":"6.665","ry":"6.51","key":0}),React.createElement("path",{"stroke":"#fff","strokeLinecap":"square","strokeLinejoin":"bevel","d":"M6.979 5.054V8.88h2.889","key":1})]);
}

Clock.defaultProps = {"width":"15","height":"15","fill":"none","viewBox":"0 0 15 15"};

module.exports = Clock;

Clock.default = Clock;
